import React from 'react'
import App from './App'
import ReactDOM from 'react-dom/client'
import { AuthProvider } from './contexts/auth-context'
import { PermissionsProvider } from './contexts/permissions-context'
import { UIProvider } from './contexts/UIContext'
import { FullscreenProvider } from './contexts/screen-context'
import { ProjectProvider } from './contexts/project-context'
import { BrandFilterProvider as DivisionProvider } from './contexts/brand-filter-context'
import { ThemeProvider } from './theme/ThemeProvider'
import './index.css'
// The variable build lets ThemeProvider recolour antd at runtime.
import 'antd/dist/antd.variable.min.css'
import './theme/tokens.css'
import './theme/antd-overrides.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <AuthProvider>
      <PermissionsProvider>
        <UIProvider>
          <FullscreenProvider>
            <DivisionProvider>
              <ProjectProvider>
                <App />
              </ProjectProvider>
            </DivisionProvider>
          </FullscreenProvider>
        </UIProvider>
      </PermissionsProvider>
    </AuthProvider>
  </ThemeProvider>,
)
